import { CheckoutStep } from "../types/common";

export const getCurrentRouteStep = (): CheckoutStep | null => {
  const searchParams = new URLSearchParams(window.location.search);
  const stepParam = searchParams.get("step");

  // Check if we're on the root "/" path (select step)
  if (
    window.location.pathname === "/" ||
    window.location.pathname === "/package-detail"
  ) {
    return "select";
  }

  // Validate step parameter
  if (
    stepParam &&
    ["select", "contact", "kyc", "payment"].includes(stepParam)
  ) {
    return stepParam as CheckoutStep;
  }

  return null;
};
